import React from 'react';
import RemovePackageCustomCategoryWeightRangeSalePriceButtonProperties from "./RemovePackageCustomCategoryWeightRangeSalePriceButtonProperties";
import RemovePackageCustomCategoryWeightRangeSalePriceStore from "./RemovePackageCustomCategoryWeightRangeSalePriceStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useCommonContext} from "../../../contexts/CommonContext";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import { useUserContext } from '../../../contexts/UserContext';


const RemovePackageCustomCategoryWeightRangeSalePriceButton: React.FC<RemovePackageCustomCategoryWeightRangeSalePriceButtonProperties> = ({
                                                                        onClick = () => {
                                                                        },
                                                                        onSave = () => {
                                                                        },
                                                                        showIcon = true,
                                                                        showText = true,
                                                                        disabled,
                                                                        className = '',
                                                                        salePriceId,
                                                                        salePriceCustomCategoryWeightRange,
                                                                        rounded = false,
                                                                        size = ButtonSize.DEFAULT,
                                                                        type = ButtonType.DEFAULT
                                                                    }) => {

    const confirm = useConfirmation();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new RemovePackageCustomCategoryWeightRangeSalePriceStore(commonContext, salePriceId, salePriceCustomCategoryWeightRange);
    
    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const handleOnclick = async () => {
        onClick();
        const ok = await confirm('Confirmación', "¿Está seguro que desea eliminar el rango?");
        if (ok) {
            await store.remove();
            onSave();
        }
    }

    const text = 'Eliminar rango';

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <Btn/>
        )}
    </Observer>
}

export default RemovePackageCustomCategoryWeightRangeSalePriceButton;

